import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable()
export class FileService {

    constructor(private http: HttpClient) {
    }
    // Unused endpoint - not called anywhere in the app
    // downloadFile(url){
    //     return this.http.get(url,
    //         {responseType: 'blob'});
    // }
}



// WEBPACK FOOTER //
// ./src/app/services/file.service.ts